import { render } from "./SignupSuccessPage.vue?vue&type=template&id=5e17d76c&scoped=true"
import script from "./SignupSuccessPage.vue?vue&type=script&lang=js"
export * from "./SignupSuccessPage.vue?vue&type=script&lang=js"

import "./SignupSuccessPage.vue?vue&type=style&index=0&id=5e17d76c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e17d76c"]])

export default __exports__